import { render, staticRenderFns } from "./SdAttributePanel.vue?vue&type=template&id=31eb0cb5&scoped=true"
import script from "./SdAttributePanel.vue?vue&type=script&lang=js"
export * from "./SdAttributePanel.vue?vue&type=script&lang=js"
import style0 from "./SdAttributePanel.vue?vue&type=style&index=0&id=31eb0cb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb0cb5",
  null
  
)

export default component.exports